/** FROZEN public surfaces (W0-contracts). Chat owns implementations and reauthorization. */
import { lazy, Suspense, type ReactElement } from 'react';
const MediaViewer=lazy(()=>import('./media/MediaViewer'));
import type { Id } from '@/model';
import { PrivateScope } from './resources/hooks';
import {MediaViewerAction} from './media/MediaViewerAction';

export interface ChatMediaViewerProps {
  conversationId: Id;
  messageId: Id;
  /** Locate the source without replacing the active timeline window. */
  seq: number;
  partIndex: number;
  onClose(): void;
}
/** Fetch current readable source by identity; no copied message/media payload or bearer URL. */
export function ChatMediaViewer(props: ChatMediaViewerProps): ReactElement | null { return <MediaViewerAction {...props}><PrivateScope key={`${props.conversationId}:${props.messageId}:${props.seq}:${props.partIndex}`}><Suspense fallback={null}><MediaViewer {...props}/></Suspense></PrivateScope></MediaViewerAction>; }
